import { colors, darkTheme, lightTheme, gotoAppDark, gotoAppLight, gotoAppPalette, } from '@getgo/chameleon-core';
import { alpha } from '@material-ui/core';
const gotoPalette = {
    'blue-700': '#00327E',
};
// Our Material-UI palette
// https://material-ui.com/customization/palette/#palette
const lightPalette = Object.assign({ type: 'light', text: {
        disabled: 'rgba(37, 40, 45, 0.36)',
        primary: colors.neutrals.n600,
        secondary: colors.neutrals.n400,
        primaryReverse: colors.neutrals.n000,
    }, background: {
        default: colors.neutrals.n000,
        disabled: '#EFF1F4',
        paper: colors.neutrals.n000,
        neutral: 'rgba(0, 0, 0, 0.08)',
        neutralLight: 'rgba(0, 0, 0, 0.04)',
        table: colors.neutrals.n050,
        tableBorder: 'rgba(224, 224, 224, 1)',
    }, primary: {
        lighter: colors.blue.b300,
        light: colors.blue.b400,
        main: colors.blue.b500,
        dark: colors.blue.b600,
        contrastText: colors.neutrals.n000,
        darker: gotoPalette['blue-700'],
        icon: lightTheme['icon-01'],
    }, secondary: {
        main: colors.blue.b500,
        dark: colors.blue.b600,
        contrastText: colors.neutrals.n000,
    }, tertiary: {
        hover: alpha(colors.blue.b300, 0.12),
        active: alpha(colors.blue.b300, 0.24),
    }, action: {
        hover: colors.blue.b600,
        focus: alpha(colors.blue.b500, 0.25),
        disabledBackground: '#EFF1F4',
        disabledBorder: 'rgba(76, 83, 93, 0.24)',
        active: gotoPalette['blue-700'],
        selected: alpha(colors.blue.b400, 0.08),
    }, info: {
        light: alpha(colors.blue.b400, 0.08),
        main: colors.blue.b500,
    }, error: {
        main: colors.red.r500,
        contrastText: colors.neutrals.n000,
    } }, colors);
const darkPalette = Object.assign({ type: 'dark', text: {
        disabled: 'rgba(255, 255, 255, 0.36)',
        primary: colors.neutrals.n000,
        secondary: 'rgba(255, 255, 255, 0.7)',
        primaryReverse: colors.neutrals.n600,
    }, background: {
        default: colors.neutrals.n600,
        disabled: '#484F57',
        paper: colors.neutrals.n600,
        neutral: 'rgba(255, 255, 255, 0.16)',
        neutralLight: 'rgba(255, 255, 255, 0.08)',
        table: colors.neutrals.n550,
        tableBorder: 'rgba(81, 81, 81, 1)',
    }, primary: {
        lighter: colors.blue.b200,
        light: colors.blue.b300,
        main: colors.blue.b400,
        dark: colors.blue.b500,
        darker: colors.blue.b600,
        contrastText: colors.neutrals.n600,
        icon: darkTheme['icon-01'],
    }, secondary: {
        main: colors.blue.b400,
        dark: colors.blue.b500,
        contrastText: colors.neutrals.n600,
    }, tertiary: {
        hover: alpha(colors.blue.b400, 0.12),
        active: alpha(colors.blue.b300, 0.24),
    }, action: {
        hover: colors.blue.b300,
        focus: alpha(colors.blue.b400, 0.24),
        disabledBackground: 'rgba(154, 168, 187, 0.16)',
        disabledBorder: 'rgba(255, 255, 255, 0.35)',
        active: colors.blue.b200,
        selected: 'rgba(0, 79, 189, 0.08)',
    }, info: {
        light: 'rgba(0, 79, 189, 0.08)',
        main: colors.blue.b400,
    }, error: {
        main: colors.red.r400,
        contrastText: colors.neutrals.n000,
    } }, colors);
const lightPaletteGh = Object.assign({ type: 'light', text: {
        disabled: 'rgba(37, 40, 45, 0.36)',
        primary: colors.neutrals.n600,
        secondary: colors.neutrals.n400,
        primaryReverse: colors.neutrals.n000,
    }, background: {
        default: colors.neutrals.n000,
        disabled: '#EFF1F4',
        paper: colors.neutrals.n000,
        neutral: 'rgba(0, 0, 0, 0.08)',
        neutralLight: 'rgba(0, 0, 0, 0.04)',
        table: colors.neutrals.n050,
        tableBorder: 'rgba(224, 224, 224, 1)',
    }, primary: {
        lighter: gotoAppPalette['green-300'],
        light: gotoAppPalette['green-400'],
        main: gotoAppLight['interactive-01'],
        dark: gotoAppPalette['green-600'],
        darker: gotoAppPalette['green-700'],
        contrastText: colors.neutrals.n000,
        icon: gotoAppLight['icon-01'],
    }, secondary: {
        main: gotoAppLight['interactive-01'],
        dark: gotoAppPalette['green-600'],
        contrastText: colors.neutrals.n000,
    }, tertiary: {
        hover: alpha(gotoAppPalette['green-300'], 0.12),
        active: alpha(gotoAppPalette['green-300'], 0.24),
    }, action: {
        hover: gotoAppLight['hover-primary'],
        focus: alpha(gotoAppPalette['green-400'], 0.25),
        disabledBackground: '#EFF1F4',
        disabledBorder: 'rgba(76, 83, 93, 0.24)',
        active: gotoAppLight['pressed-primary'],
        selected: alpha(gotoAppPalette['green-400'], 0.08),
    }, info: {
        light: alpha(gotoAppPalette['green-400'], 0.08),
        main: gotoAppPalette['green-500'],
    }, error: {
        main: colors.red.r500,
        contrastText: colors.neutrals.n000,
    } }, colors);
const darkPaletteGh = Object.assign({ type: 'dark', text: {
        primary: colors.neutrals.n000,
        secondary: 'rgba(255, 255, 255, 0.7)',
        primaryReverse: colors.neutrals.n600,
    }, background: {
        default: colors.neutrals.n600,
        disabled: '#484F57',
        paper: colors.neutrals.n600,
        neutral: 'rgba(255, 255, 255, 0.16)',
        neutralLight: 'rgba(255, 255, 255, 0.08)',
        table: colors.neutrals.n550,
        tableBorder: 'rgba(81, 81, 81, 1)',
    }, primary: {
        lighter: gotoAppPalette['green-200'],
        light: gotoAppPalette['green-300'],
        main: gotoAppDark['interactive-01'],
        dark: gotoAppPalette['green-500'],
        darker: gotoAppPalette['green-600'],
        contrastText: colors.neutrals.n600,
        icon: gotoAppDark['icon-01'],
    }, secondary: {
        main: gotoAppDark['interactive-01'],
        dark: gotoAppPalette['green-500'],
        contrastText: colors.neutrals.n600,
    }, tertiary: {
        hover: alpha(gotoAppPalette['green-300'], 0.12),
        active: alpha(gotoAppPalette['green-300'], 0.24),
    }, action: {
        hover: gotoAppDark['hover-primary'],
        focus: alpha(gotoAppPalette['green-400'], 0.25),
        disabledBackground: 'rgba(154, 168, 187, 0.16)',
        disabledBorder: 'rgba(255, 255, 255, 0.35)',
        active: gotoAppDark['pressed-primary'],
        selected: alpha(gotoAppPalette['green-500'], 0.08),
    }, info: {
        light: alpha(gotoAppPalette['green-500'], 0.08),
        main: gotoAppPalette['green-400'],
    }, error: {
        main: colors.red.r400,
        contrastText: colors.neutrals.n000,
    } }, colors);
export { lightPalette, darkPalette, lightPaletteGh, darkPaletteGh };
